import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, IconButton, Typography } from "@mui/material";

interface CreateMenuItemHeaderProps {
  title: string;
  handleClose: () => void;
  handleSave: () => void;
  saveLabel?: string;
  pageView?: boolean;
}

export const CreateMenuItemHeader = ({
  title,
  handleClose,
  handleSave,
  saveLabel = "Save",
  pageView = false,
}: CreateMenuItemHeaderProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: 2, overflowY: "hidden" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h2">{title}</Typography>
        {pageView ? (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button onClick={handleSave}>{saveLabel}</Button>
          </Box>
        ) : (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button onClick={handleSave}>{saveLabel}</Button>
            <IconButton onClick={handleClose} size="small" aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Box>
        )}
      </Box>
      <Divider />
    </Box>
  );
};
